// AI Aerial Imagery — main entry
// Scroll reveals + optional hero canvas (only on home page)

function setupReveal() {
  const supportsScrollTimeline = CSS.supports('animation-timeline: view()');
  if (supportsScrollTimeline) return;

  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
      }
    }
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
}

// Minimal WebGL2 hero canvas — static grid pattern that pulses gently
function initHeroCanvas() {
  const canvas = document.getElementById('hero-canvas');
  if (!canvas) return;

  const gl = canvas.getContext('webgl2', { alpha: true, antialias: true });
  if (!gl) { canvas.style.display = 'none'; return; }

  const VERT = `#version 300 es
precision highp float;
uniform vec2 uRes;
uniform float uTime;
out vec2 vUv;
out float vGrid;
void main() {
  vec2 uv = (gl_VertexID == 0) ? vec2(-1.0, -1.0) :
            (gl_VertexID == 1) ? vec2(3.0, -1.0) : vec2(-1.0, 3.0);
  gl_Position = vec4(uv, 0.0, 1.0);
  vUv = uv * 0.5 + 0.5;
  vGrid = 0.0;
}
`;

  const FRAG = `#version 300 es
precision highp float;
uniform float uTime;
in vec2 vUv;
out vec4 fragColor;
float hash(vec2 p) { return fract(sin(dot(p, vec2(127.1, 311.7))) * 43758.5453); }
void main() {
  vec2 p = vUv * 20.0;
  vec2 grid = fract(p);
  float line = max(
    smoothstep(0.0, 0.03, grid.x) * smoothstep(0.03, 0.0, grid.x),
    smoothstep(0.0, 0.03, grid.y) * smoothstep(0.03, 0.0, grid.y)
  );
  float cell = hash(floor(p));
  float pulse = 0.5 + 0.5 * sin(uTime * 0.3 + cell * 6.28);
  float alpha = line * 0.06 * (0.4 + 0.6 * pulse);
  vec3 col = mix(vec3(0.3, 0.5, 0.8), vec3(0.5, 0.7, 1.0), pulse);
  fragColor = vec4(col, alpha * (1.0 - vUv.y * 0.5));
}
`;

  function compile(src, type) {
    const s = gl.createShader(type);
    gl.shaderSource(s, src);
    gl.compileShader(s);
    return gl.getShaderParameter(s, gl.COMPILE_STATUS) ? s : null;
  }

  const vs = compile(VERT, gl.VERTEX_SHADER);
  const fs = compile(FRAG, gl.FRAGMENT_SHADER);
  if (!vs || !fs) { canvas.style.display = 'none'; return; }

  const prog = gl.createProgram();
  gl.attachShader(prog, vs);
  gl.attachShader(prog, fs);
  gl.linkProgram(prog);
  if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) { canvas.style.display = 'none'; return; }

  const uRes = gl.getUniformLocation(prog, 'uRes');
  const uTime = gl.getUniformLocation(prog, 'uTime');

  gl.enable(gl.BLEND);
  gl.blendFunc(gl.ONE, gl.ONE);

  function resize() {
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = canvas.clientWidth * dpr;
    canvas.height = canvas.clientHeight * dpr;
    gl.viewport(0, 0, canvas.width, canvas.height);
  }
  resize();
  window.addEventListener('resize', resize);

  let raf;
  function frame(now) {
    raf = requestAnimationFrame(frame);
    resize();
    gl.useProgram(prog);
    gl.uniform2f(uRes, canvas.width, canvas.height);
    gl.uniform1f(uTime, now / 1000);
    gl.clearColor(0, 0, 0, 0);
    gl.clear(gl.COLOR_BUFFER_BIT);
    gl.drawArrays(gl.TRIANGLES, 0, 3);
  }
  raf = requestAnimationFrame(frame);
}

setupReveal();
initHeroCanvas();
